
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { UsersOverview } from "@/components/admin/UsersOverview";
import { AdminFeedbackTable } from "@/components/admin/feedback/AdminFeedbackTable";

export default function AdminDashboard() {
  return (
    <div className="space-y-6">
      <h1 className="text-3xl font-bold">Admin Dashboard</h1>
      
      <div className="space-y-6">
        <UsersOverview />

        <Card>
          <CardHeader>
            <CardTitle>Feedback Overzicht</CardTitle>
          </CardHeader>
          <CardContent>
            <AdminFeedbackTable />
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
